import { useHistory } from "react-router-dom";
import { ReactComponent as StatisticsIcon } from "../../assets/images/Statistics.svg";

export const AdoptionCell = (route) => {
  return function StatisticsCell(params) {
    const history = useHistory();
    const { version, uploadedDate } = params.row;

    const handleClick = () => {
      history.push({
        pathname: `/dashboard/${route}/adoption`,
        state: { version, uploadedDate }, // pass label too if needed
      });
    };

    return (
      <div onClick={handleClick} style={{ cursor: "pointer" }}>
        <StatisticsIcon />
      </div>
    );
  };
};
